import type { Rect } from '@/types/ainotebook'

export function inflateRect(r: Rect, padX: number, padY: number, maxW: number, maxH: number): Rect {
  const x = Math.max(0, r.x - padX)
  const y = Math.max(0, r.y - padY)
  const w = Math.min(maxW - x, r.w + padX * 2)
  const h = Math.min(maxH - y, r.h + padY * 2)
  return { x, y, w, h }
}

export function median(arr: number[]) {
  if (!arr.length) return 0
  const a = [...arr].sort((x, y) => x - y)
  const m = Math.floor(a.length / 2)
  return a.length % 2 ? a[m] : (a[m - 1] + a[m]) / 2
}

export function avg(nums: number[]) {
  if (!nums.length) return undefined
  return nums.reduce((a, b) => a + b, 0) / nums.length
}
